<ngx-login
	(onSignUp)="toSignUp()"
	(onForgotPassword)="forgotPassword()"
	(onLogin)="submit($event)"
	(onLoginWithSso)="loginWithSso($event)"
	[disabledButton]="loading$ | async"
	[errorMessage]="formError$ | async">
</ngx-login>